var React = require('react');

function LinkedinBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"linkedinblack_Path_370","data-name":"linkedinblack_Path 370","d":"M50.743,56.387v-11H47.1v11ZM48.915,43.873a1.907,1.907,0,1,0-2.045-1.9,1.879,1.879,0,0,0,2.021,1.9Zm3.853,12.506h3.656V50.244a2.517,2.517,0,0,1,.121-.894,2,2,0,0,1,1.876-1.338c1.324,0,1.854,1,1.854,2.489v5.886h3.656v-6.31c0-3.379-1.808-4.952-4.219-4.952a3.645,3.645,0,0,0-3.321,1.854h.024v-1.6H52.768c.048,1.033,0,11,0,11Z","transform":"translate(-46.87 -40.07)","fill":"#1a1a1a"}));
}

LinkedinBlack.defaultProps = {"width":"17.062","height":"16.317","viewBox":"0 0 17.062 16.317"};

module.exports = LinkedinBlack;

LinkedinBlack.default = LinkedinBlack;
